import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_sheet, { class: "pa-6 elevation-2" }, {
      default: _withCtx(() => [
        _createVNode($setup["AdminBills"], {
          bills: $setup.bills,
          onRefresh: $setup.fetchBills
        }, null, 8, ["bills"])
      ]),
      _: 1
    })
  ]))
}